import React,{useState} from 'react';
import { makeStyles } from "@material-ui/core/styles";
import {Card,CardContent,Box} from "@material-ui/core";
import NumberFormat from 'react-number-format';
const useStyles = makeStyles((theme) => ({
    card:{
        height:'4.1rem',
        width:90,
          color:"white",
        backgroundColor:process.env.REACT_APP_Fondo_Color,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    card2:{
        height:'4.1rem',
        width:100,
          color:"white",
        backgroundColor:process.env.REACT_APP_Fondo_Color,
       // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
      },
    card3:{
        height:'4.1rem',
        width:100,
          color:"white",
        backgroundColor:process.env.REACT_APP_Fondo_Color,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    titulo:{
        //color:'#4a4a4a',
        textAlign:'center',
        marginTop:'-.4rem',
        fontSize:'1rem',
        fontWeight:600
    },
    tituloColor:{

        //color:'white',
        textAlign:'center',
        marginTop:'-.6rem',
        fontSize:'1.2rem',
        fontWeight:600
    },
    subtitulo:{
        //color:'#4a4a4a',
        textAlign:'center',
        marginTop:'-1.4rem',
        fontSize:'.8rem',
    },
    subtituloCard:{
       // color:'#4a4a4a',
        textAlign:'center',
        marginTop:'.1rem',
        fontSize:'1rem',
    },
}));


export default function CardTotal({valor, dtoRegistro}){
    const classes = useStyles();
    const[total,setTotal]= useState([])
    const auxColor=process.env.REACT_APP_Fondo_Color
    React.useEffect(()=>{    
        const auxGralMun=valor.ComunaAvc 
        const auxGralSec=valor.DtoAvc               
        const auxTotMun=valor.ComunaTot 
        const auxTotSec=valor.DtoTot      
        const auxTotal=valor.GenBinario + valor.GenHombre + valor.GenMujer         
        setTotal({
            gralMun:auxGralMun,gralSec:auxGralSec,
            totMun:auxTotMun,totSec:auxTotSec,             
            totAv:auxTotal
        })
     },[valor])  

    function generarCards(mensaje,datos,auxColor){
        return( 
        <CardContent>
            <Card className={classes.tituloColor} 
                style={{backgroundColor:auxColor,color:'white'}} 
            >                
                <NumberFormat value={datos} displayType={'text'}  thousandSeparator={true}/>
            </Card>
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>
        </CardContent>
        )
    }
    function generarCards2(mensaje,datGen,datTot,auxColor){
        return( 
        <CardContent>
            <Card className={classes.tituloColor} 
                style={{backgroundColor:auxColor,color:'white'}} 
            >                
                <NumberFormat value={datGen} displayType={'text'}  thousandSeparator={true}/>
                {' / '}
                <NumberFormat value={datTot} displayType={'text'}  thousandSeparator={true}/>
            </Card>
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>
        </CardContent>
        )
    }

    function generarCards3(mensaje,datGen,datTot,auxColor){
        return( 
        <CardContent>
            <div //className={classes.tituloColor} 
                style={{ textAlign:'center',
        marginTop:'-.6rem',
        fontSize:'1rem',
        fontWeight:600}} 
            >                
                <NumberFormat value={datGen} displayType={'text'}  thousandSeparator={true}/>
                {' / '}
                <NumberFormat value={datTot} displayType={'text'}  thousandSeparator={true}/>
            </div>
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>
        </CardContent>
        )
    }

    function generarCards4(mensaje,datGen,){
        return( 
        <CardContent>
            <div //className={classes.tituloColor} 
                style={{ textAlign:'center',
        marginTop:'-.6rem',
        fontSize:'1rem',
        fontWeight:600}} 
            >                
                <NumberFormat value={datGen} displayType={'text'}  thousandSeparator={true}/>                
            </div>
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>
        </CardContent>
        )
    }

    return (         
    <Box display="flex" flexDirection="row" mb={1}  >   
        <Box display="flex" flexDirection="row">                                    
            <Card className={classes.card}>
                {generarCards3('Comuna',total.gralMun, total.totMun,auxColor)}
            </Card>
            <Card className={classes.card3}>
                {generarCards3('Distrito',total.gralSec, total.totSec,auxColor)}
            </Card>
            <Card className={classes.card3}>
                {generarCards4('Total',total.totAv )}
            </Card>
        </Box>   
    </Box>
    );
}
 